import React from "react";

const CreateChannel = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <circle className="u_fill" cx={18} cy={9.333} r={5.333} fill={fill} />
        <circle className="u_fill" cx={7.333} cy={26.727} r={5.333} fill={fill} />
        <circle className="u_fill" cx={28.667} cy={26.727} r={5.333} fill={fill} />
        <path className="u_fill"
            fill={fill}
            d="M19.494 13.859l1.833-1.091 5.456 9.166-1.833 1.091zM16.311 13.859l-1.833-1.091-5.456 9.166 1.833 1.09zM23.48 27.779l-.005-2.133-11.733.031.006 2.133z"
        />
    </svg>
);

export default CreateChannel;
